module.exports = __webpack_public_path__ + "img/picture.f46e4bfb.png";